var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('card',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("Propriedades Clientes")])]),_c('div',{staticClass:"mt-4 mb-4"},[_c('region-map',{attrs:{"markers":_vm.properties,"height":500,"zoom":6,"readOnly":""},on:{"update:markers":function($event){_vm.properties=$event}}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }